import { Component, Input } from '@angular/core';
import { SlideOutPanelService } from './slide-out-panel.service';
import { Observable } from 'rxjs';
import { MatDrawerMode } from '@angular/material/sidenav';

@Component({
  selector: 'sales-ui-slide-out-panel',
  templateUrl: './slide-out-panel.component.html',
  styleUrls: ['./slide-out-panel.component.scss'],
})
export class SlideOutPanelComponent {
  public readonly isOpened$: Observable<boolean>;
  @Input() mode: MatDrawerMode = 'side';
  events: string;

  constructor(private readonly slideOutPanelService: SlideOutPanelService) {
    this.isOpened$ = slideOutPanelService.isSlideOutOpen$;
  }

  closeSideNav(): void {
    this.slideOutPanelService.closeSlideOut();
  }
}
